module.exports = __webpack_public_path__ + "static/media/1.0d4c924f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16020/1.jpg
// module id = 512
// module chunks = 0